import React from 'react';

import { UaDevice } from 'types/enums';

const DeviceTypeContext = React.createContext<UaDevice>(UaDevice.Mobile);

export default DeviceTypeContext;
